// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"2122632c","286":"20770341","435":"adb2b5f1","453":"d48df938","574":"8b0f88d8","642":"e98a4b17","728":"ff5aaa71","872":"a654b9d6","915":"5f79e2a5","994":"28a8e54e"}[chunkId] + ".chunk.js";
};